$('.casestudycarousel__slides--new').slick({
  slidesToShow: 1,
  slidesToScroll: 1,
  infinite: true,
  autoplay: false,
  arrows: false,
  dots: false,
  touchThreshold: 100,
  mobileFirst: true,
  cssEase: 'cubic-bezier(.37,1.02,.36,1.04)',
  responsive: [
    {
      breakpoint: 680,
      settings: {
        slidesToShow: 3
      }
    }
  ]
});
